import Swiper from 'swiper';
import {Pagination, Navigation, Autoplay} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import {Fancybox} from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

document.addEventListener('DOMContentLoaded', function () {
    const fogaesInfo = document.getElementById('btn-fogaes');

    Fancybox.bind("[data-fancybox]", {
        Toolbar: {
            display: {
                left: ["infobar"],
                middle: [],
                right: ["close"],
            },
        },
    });

    const swiperHeroEl = document.querySelector('.swiper-hero')
    if (swiperHeroEl) {
        const heroCount = parseInt(swiperHeroEl.dataset.heroCount);

        const swiperHero = new Swiper('.swiper-hero', {
            modules: [Autoplay, Navigation],
            slidesPerView: 1,
            spaceBetween: 0,
            mousewheel: true,
            loop: `${heroCount > 1}`,
            /*
            autoplay: {
                delay: 2000,
                disableOnInteraction: true,
                pauseOnHover: true,
            },
             */
            navigation: {
                nextEl: '.swiper-button-next-hero',
                prevEl: '.swiper-button-prev-hero',
            },
            breakpoints: {}
        });
    } else {
        console.warn('⚠️ Elemento Swiper No Encontrado');
    }

    const swiperBenefitsEl = document.querySelector('.swiper-benefits')
    if (swiperBenefitsEl) {
        const benefitsCount = parseInt(swiperBenefitsEl.dataset.heroCount);

        const swiperBenefits = new Swiper('.swiper-benefits', {
            modules: [Autoplay, Navigation, Pagination],
            slidesPerView: 3,
            spaceBetween: 0,
            mousewheel: true,
            loop: `${benefitsCount > 1}`,
            autoplay: {
                delay: 2000,
                disableOnInteraction: true,
                pauseOnHover: true,
            },
            navigation: {
                nextEl: '.swiper-button-next-benefits',
                prevEl: '.swiper-button-prev-benefits',
            },
            pagination: {
                el: '.swiper-pagination-benefits',
                type: 'bullets',
                dynamicBullets: true,
                dynamicMainBullets: 1,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                640: {
                    slidesPerView: 1.25,
                    spaceBetween: 5,
                },
                768: {
                    slidesPerView: 1.6,
                    spaceBetween: 5,
                },
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 5,
                },
                1280: {
                    slidesPerView: 2.6,
                    spaceBetween: 5,
                },
                1440: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                },
                1536: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                },
            }
        });
    } else {
        console.warn('⚠️ Elemento Swiper No Encontrado');
    }

    const swiperNewProjectsEl = document.querySelector('.swiper-new-projects')
    if (swiperNewProjectsEl) {
        const newProjectsCount = parseInt(swiperNewProjectsEl.dataset.newCount);
        const maxSlidesPerView = 4;
        const isSafeToLoop = newProjectsCount > maxSlidesPerView;
        const swiperNewProjects = new Swiper('.swiper-new-projects', {
            modules: [Autoplay, Navigation, Pagination],
            slidesPerView: 3,
            spaceBetween: 0,
            mousewheel: true,
            loop: isSafeToLoop,
            rewind: !isSafeToLoop,
            watchOverflow: true,
            autoplay: {
                delay: 2000,
                disableOnInteraction: true,
                pauseOnHover: true,
            },
            navigation: {
                nextEl: '.swiper-button-next-new-projects',
                prevEl: '.swiper-button-prev-new-projects',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                },
                1280: {
                    slidesPerView: getSlidesPerView(newProjectsCount, 3, .8, 5),
                    spaceBetween: 20,
                },
                1440: {
                    slidesPerView: getSlidesPerView(newProjectsCount, 3, .95, 0),
                    spaceBetween: 20,
                },
                1536: {
                    slidesPerView: getSlidesPerView(newProjectsCount, 4, .05, 5),
                    spaceBetween: 20,
                },
                1920: {
                    slidesPerView: getSlidesPerView(newProjectsCount, 4, .05, 5),
                    spaceBetween: 5,
                },
            }
        });
    } else {
        console.warn('⚠️ Elemento Swiper No Encontrado');
    }

    const swiperLastProjectsEl = document.querySelector('.swiper-last-projects');
    if (swiperLastProjectsEl) {
        const lastProjectsCount = parseInt(swiperLastProjectsEl.dataset.lastCount);
        const maxSlidesPerView = 4;
        const isSafeToLoop = lastProjectsCount > maxSlidesPerView;

        const swiperLastProjects = new Swiper('.swiper-last-projects', {
            modules: [Autoplay, Navigation],
            mousewheel: true,
            loop: isSafeToLoop,
            rewind: !isSafeToLoop,
            watchOverflow: true,
            navigation: {
                nextEl: '.swiper-button-next-last-projects',
                prevEl: '.swiper-button-prev-last-projects',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                },
                1280: {
                    slidesPerView: getSlidesPerView(lastProjectsCount, 3, .8, 5),
                    spaceBetween: 20,
                },
                1536: {
                    slidesPerView: getSlidesPerView(lastProjectsCount, 4, .05, 5),
                    spaceBetween: 20,
                }
            }
        });
    } else {
        console.warn('⚠️ Elemento Swiper No Encontrado');
    }

    const swiperSoldOutProjectsEl = document.querySelector('.swiper-soldout-projects');
    if (swiperSoldOutProjectsEl) {
        const soldOutProjectsCount = parseInt(swiperSoldOutProjectsEl.dataset.soldoutCount);
        const maxSlidesPerView = 4;
        const isSafeToLoop = soldOutProjectsCount > maxSlidesPerView;

        const swiperSoldOutProjects = new Swiper('.swiper-soldout-projects', {
            modules: [Autoplay, Navigation],
            mousewheel: true,
            loop: isSafeToLoop,
            rewind: !isSafeToLoop,
            watchOverflow: true,
            navigation: {
                nextEl: '.swiper-button-next-soldout-projects',
                prevEl: '.swiper-button-prev-soldout-projects',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                },
                1280: {
                    slidesPerView: getSlidesPerView(soldOutProjectsCount, 3, .8, 5),
                    spaceBetween: 20,
                },
                1536: {
                    slidesPerView: getSlidesPerView(soldOutProjectsCount, 4, .05, 5),
                    spaceBetween: 20,
                }
            }
        });
    } else {
        console.warn('⚠️ Elemento Swiper No Encontrado');
    }

    function getSlidesPerView(count, full, peek, threshold = full + 1) {
        if (count >= threshold) return full + peek;
        return Math.min(count, full);
    }
});
